import { useSendbird } from '@sendbird/uikit-react';
import { useSendbirdChannelUrlCore } from './useSendbirdChannelUrlCore';

const useSendbirdChannelUrl = () => {
  const {
    state: { stores },
  } = useSendbird();
  const { sdk, initialized } = stores.sdkStore;

  return useSendbirdChannelUrlCore(sdk.groupChannel, initialized);
};

export default useSendbirdChannelUrl;
